import errorLink from '@magalu/ecomm-components/rave/apollo/errorLink';

export const middlewares = [errorLink('mixer-web', ['suggestQuery'])];
